export const VERSION = '8.32.0';
